import React, {
    useContext,
    useEffect,
    useState,
} from 'react';
import { Link } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBell,
    faListNumeric,
    faChartSimple,
    faUser,
    faFileExport,
    faTicket,
    faGear,
    faPowerOff,
    faBars,
    faXmark,
    faMapMarker,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';

import Logo from '../resources/logo.png';
import LogoWhite from '../resources/logo_white.png';
import User from '../api/User';
import ExportModal from './exportModal';
import { SessionContext } from '../SessionContext';

function Menu({ active }) {
    const {
        session,
        sessionLoaded,
    } = useContext(SessionContext);

    const [menuOpen, setMenuOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [numberNotifications, setNumberNotifications] = useState(0);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const toggleMenu = () => {
        setMenuOpen((currentValue) => !currentValue);
    };

    const handleCloseExportModal = () => {
        setIsExportModalOpen(false);
    };

    useEffect(() => {
        if (!sessionLoaded || !session) {
            return;
        }

        const hasAdminRole = Array.isArray(session.roles)
            && session.roles.some(
                (role) => role.name === 'super'
            );

        setIsAdmin(hasAdminRole);

        setNumberNotifications(
            Number(session.notifications || 0)
        );

        const refreshNotifications = async () => {
            try {
                const response = await User.getSession();

                setNumberNotifications(
                    Number(response.data.notifications || 0)
                );
            } catch (error) {
                console.error(
                    'Erro ao atualizar notificações:',
                    error
                );
            }
        };

        refreshNotifications();
    }, [sessionLoaded, session]);

    const handleLogout = async () => {
        if (isLoggingOut) {
            return;
        }

        setIsLoggingOut(true);

        const loginPortalUrl = (
            process.env.REACT_APP_LOGIN_PORTAL_URL || ''
        ).replace(/\/+$/, '');

        try {
            await User.logout();
        } catch (error) {
            console.error(
                'Erro ao terminar a sessão do Carsharing:',
                error
            );
        } finally {
            if (!loginPortalUrl) {
                console.error(
                    'A variável REACT_APP_LOGIN_PORTAL_URL não está configurada no .env.'
                );

                setIsLoggingOut(false);

                return;
            }

            window.location.replace(
                `${loginPortalUrl}/dashboard`
            );
        }
    };

    return (
        <div>
            <div
                className={
                    `menu-overlay d-sm-none ${menuOpen ? 'open' : ''}`
                }
            />

            <div
                className={
                    `menu-container ${menuOpen ? 'open' : ''}`
                }
            >
                <div className="menu-logo-container">
                    <img
                        className="menu-logo"
                        src={Logo}
                        alt="Conduril"
                    />
                </div>

                <div className="menu-bell">
                    <Link to="/notifications">
                        <Badge
                            badgeContent={numberNotifications}
                            color="error"
                        >
                            <FontAwesomeIcon
                                icon={faBell}
                                size="2xl"
                                style={{ color: '#ffd500' }}
                            />
                        </Badge>
                    </Link>
                </div>

                {session && (
                    <div className="menu-list">
                        <div
                            className={
                                `menu-item ${
                                    active === 'dashboard'
                                        ? 'active'
                                        : ''
                                }`
                            }
                        >
                            <Link to="/dashboard">
                                <FontAwesomeIcon icon={faChartSimple} />
                                <span>Dashboard</span>
                            </Link>
                        </div>

                        <div
                            className={
                                `menu-item ${
                                    active === 'mytrips'
                                        ? 'active'
                                        : ''
                                }`
                            }
                        >
                            <Link to="/mytrips">
                                <FontAwesomeIcon icon={faUser} />
                                <span>Minhas Viagens</span>
                            </Link>
                        </div>

                        {isAdmin && (
                            <div
                                className={
                                    `menu-item ${
                                        active === 'all-trips'
                                            ? 'active'
                                            : ''
                                    }`
                                }
                            >
                                <Link to="/all-trips">
                                    <FontAwesomeIcon icon={faListNumeric} />
                                    <span>Histórico Viagens</span>
                                </Link>
                            </div>
                        )}

                        {isAdmin && (
                            <div
                                className={
                                    `menu-item ${
                                        active === 'destinies'
                                            ? 'active'
                                            : ''
                                    }`
                                }
                            >
                                <Link to="/destinies">
                                    <FontAwesomeIcon icon={faMapMarker} />
                                    <span>Destinos</span>
                                </Link>
                            </div>
                        )}

                        {isAdmin && (
                            <div
                                className={
                                    `menu-item ${
                                        active === 'export'
                                            ? 'active'
                                            : ''
                                    }`
                                }
                                onClick={() => {
                                    setIsExportModalOpen(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faFileExport} />
                                <span>Exportação</span>
                            </div>
                        )}

                        <div
                            className={
                                `menu-item ${
                                    active === 'tickets'
                                        ? 'active'
                                        : ''
                                }`
                            }
                        >
                            <Link to="/tickets">
                                <FontAwesomeIcon icon={faTicket} />
                                <span>Tickets</span>
                            </Link>
                        </div>

                        {isAdmin && (
                            <div
                                className={
                                    `menu-item ${
                                        active === 'roles'
                                            ? 'active'
                                            : ''
                                    }`
                                }
                            >
                                <Link to="/roles">
                                    <FontAwesomeIcon icon={faUsers} />
                                    <span>Roles</span>
                                </Link>
                            </div>
                        )}

                        <div
                            className={
                                `menu-item ${
                                    active === 'settings'
                                        ? 'active'
                                        : ''
                                }`
                            }
                        >
                            <Link to="/settings">
                                <FontAwesomeIcon icon={faGear} />
                                <span>Definições</span>
                            </Link>
                        </div>

                        {isAdmin && (
                            <div
                                className={
                                    `menu-item ${
                                        active === 'job-planner'
                                            ? 'active'
                                            : ''
                                    }`
                                }
                            >
                                <Link to="/job-planner">
                                    <FontAwesomeIcon icon={faUsers} />
                                    <span>Gerir jobs</span>
                                </Link>
                            </div>
                        )}
                    </div>
                )}

                <button
                    type="button"
                    className="menu-item btn-logout"
                    onClick={handleLogout}
                    disabled={isLoggingOut}
                >
                    <FontAwesomeIcon icon={faPowerOff} />

                    <span>
                        {isLoggingOut
                            ? 'A sair...'
                            : 'Logout'}
                    </span>
                </button>
            </div>

            <div className="menu-top-mobile d-sm-none">
                <img
                    className="menu-logo"
                    src={LogoWhite}
                    alt="Conduril"
                />

                <button
                    type="button"
                    className="btn-open-menu"
                    onClick={toggleMenu}
                >
                    <FontAwesomeIcon
                        icon={menuOpen ? faXmark : faBars}
                    />
                </button>
            </div>

            {isExportModalOpen && (
                <ExportModal
                    isOpen={isExportModalOpen}
                    onClose={handleCloseExportModal}
                />
            )}
        </div>
    );
}

export default Menu;